import { type RefObject } from "react";
import { Text } from "@jsq/ds/core";
import { useFormContext } from "@jsq/ds/forms";
import {
  type FormFieldConfig,
  type SectionActionHandle,
  type TaxFormValues,
} from "../../types";
import { FIELD_RENDERERS } from "./fieldRenderers";
import * as styles from "./styles_vanilla.css";

const resolveLabel = (
  label: string | ((values: TaxFormValues) => string),
  values: TaxFormValues,
): string => {
  if (typeof label === "function") {
    return label(values);
  }
  return label;
};

export type DynamicFieldProps = {
  field: FormFieldConfig;
  actionRef?: RefObject<SectionActionHandle | null>;
};

export const DynamicField = ({ field, actionRef }: DynamicFieldProps) => {
  const { values } = useFormContext<TaxFormValues>();
  const isVisible = field.showWhen ? field.showWhen(values) : true;

  if (!isVisible) return null;

  const flexBasisClass =
    field.gridColumn === "full" ? styles.fieldWrapperFull : styles.fieldWrapperHalf;
  const resolvedLabel = resolveLabel(field.label, values);

  const renderer = FIELD_RENDERERS[field.type];
  const renderedField = renderer ? renderer(field, resolvedLabel, actionRef) : null;

  return (
    <div className={`${styles.fieldWrapper} ${flexBasisClass}`}>
      {renderedField}
      {field.helpText && (
        <Text variant="secondary-sm" className={styles.helpText}>
          {field.helpText}
        </Text>
      )}
    </div>
  );
};
